import React from 'react';
import { Helmet } from 'react-helmet-async';
import siteConfig from '../../utils/seoConfig';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  author,
  publishedDate,
  modifiedDate,
  category,
  type = "website",
  url
}) => {
  const siteUrl = url || (typeof window !== 'undefined' ? window.location.href : siteConfig.siteUrl);
  const ogImage = image || siteConfig.defaultImage;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {author && <meta name="author" content={author} />}

      {/* Open Graph Meta Tags */}
      <meta property="og:site_name" content={siteConfig.siteName} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:secure_url" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={siteConfig.twitterHandle} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {siteConfig.twitterHandle && <meta name="twitter:creator" content={siteConfig.twitterHandle} />}

      {/* Article Meta Tags (for blog posts) */}
      {type === "article" && (
        <>
          {publishedDate && <meta property="article:published_time" content={publishedDate} />}
          {modifiedDate && <meta property="article:modified_time" content={modifiedDate} />}
          {category && <meta property="article:section" content={category} />}
          {author && <meta property="article:author" content={author} />}
        </>
      )}

      {/* Additional SEO Tags */}
      <link rel="canonical" href={siteUrl} />
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
    </Helmet>
  );
};

export default SEO;
